// removed by extract-text-webpack-plugin
module.exports = {"upload":"upload--9ae20"};